/*
 * @Author: 17388316638 lemon1234..
 * @Date: 2022-09-09 10:04:53
 * @LastEditors: 17388316638 lemon1234..
 * @LastEditTime: 2022-09-09 11:24:03
 * @FilePath: \qcsdjyBigdataUI\src\router\ly.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
export default [
  {
    path: "/",
    redirect: "/login",
  },
  {
    path: "/scenicSpotBigData",
    name: "scenicSpotBigData",
    component: () =>
      import(
        /* webpackChunkName: "about" */ "../views/scenicSpotBigData/index.vue"
      ),
    meta: {
      bgType: 2,
    },
  },
  {
    path: "/login",
    name: "login",
    component: () => import("@/views/login/index.vue"),
  },
];
